module.exports = __webpack_public_path__ + "f0aafc573fb8bc263506f3245b9049a1.jpg";